module.exports = __webpack_public_path__ + "img/hotel-21.2f526ae2.jpeg";